// extracted by mini-css-extract-plugin
export default {"signup":"SignUpStep_signup__jAmlS","info":"SignUpStep_info__QYiQW","signupForm":"SignUpStep_signupForm__Prgii"};